import * as React from "react";
import { Textarea } from "ui/textarea";
import { IoMdSend } from "react-icons/io";
import { AiChatAssistantTextAreaMaxLength } from "app/components/ai-chat-assistant/constants";
import { StopChatButton } from "app/components/ai-chat-assistant/components/stop-ai-chat-assistant";
import styles from "./chat-input.scss";

export const ChatInput = ({ inputText, setInputText, send, running, placeholder, abortChat, onKeyDown, className }:
  {
    inputText: string, setInputText: (value: string) => void,
    send: () => void, running: boolean,
    placeholder: string,
    abortChat: () => void;
    onKeyDown?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
    className?: string;
  }) => (
  <div className={`${styles.chatInputWrapper} ${className || ""}`}>
    <Textarea
      className={styles.chatInput}
      value={inputText}
      onChange={setInputText}
      placeholder={placeholder}
      wait={100}
      maxLength={AiChatAssistantTextAreaMaxLength}
      onKeyDown={onKeyDown}
    />
    <div className={styles.btnWrapper}>
      {running ? (
        <StopChatButton
          isStreaming={running}
          onAbortChat={abortChat}
        />
      ) : (
        <button onClick={send} disabled={running || !inputText.trim()} className={styles.btnSend} aria-label="send">
          <IoMdSend />
        </button>
      )}
    </div>
  </div>
);
